// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1n3Dj","subheader":"ReorderModal_subheader__2j0OQ","listWrap":"ReorderModal_listWrap__1IvH8"};